import { render, staticRenderFns } from "./Summernote.vue?vue&type=template&id=6e0003ca&scoped=true&"
import script from "./Summernote.vue?vue&type=script&lang=js&"
export * from "./Summernote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0003ca",
  null
  
)

export default component.exports